import { FlyoutPosition } from "./interfaces";
export var FlyoutDefaultProps = {
  role: 'dialog',
  position: FlyoutPosition.Trailing,
  shouldCloseOnClickOutside: true
};
export var FlyoutContentDefaultProps = {
  maxWidth: 600,
  closeButtonAltText: 'Close dialog'
};
export var withFlyoutDefaultProps = {
  flyoutPosition: FlyoutPosition.Trailing
};
export var BODY_PADDING_LARGE_VIEWPORT = 'S500';
export var BODY_PADDING_SMALL_VIEWPORT = 'S300';
export var BODY_PADDING_IN_HIGH_ZOOM_LEVEL = 'S200';
export var HEADER_PADDING_LARGE_VIEWPORT = ['S300', 'S500'];
export var HEADER_PADDING_SMALL_VIEWPORT = 'S300';
export var HEADER_PADDING_IN_HIGH_ZOOM_LEVEL = 'S200';
export var FOOTER_GRID_GAP = 'S300';
export var FOOTER_PADDING = 'S300';
export var FLYOUT_TITLE_ID = 'stencil-flyout-title';